module.exports = __webpack_public_path__ + "img/wine_grey.8dde1b11.svg";